import { z } from 'zod';

export const ProjectMaterialSchema = z.object({
  id: z.string().uuid(),
  project_id: z.string().uuid(),
  spec_code: z.string(),
  material_id: z.string().uuid(),
  material_group: z.string(),
  notes: z.string().nullable(),
});

export const CreateProjectMaterialSchema = z.object({
  project_id: z.string().uuid(),
  spec_code: z.string().min(1, 'Spec code is required'),
  material_id: z.string().uuid(),
  material_group: z.string().min(1, 'Material group is required'),
  notes: z.string().nullable().optional(),
});

export const UpdateProjectMaterialSchema = CreateProjectMaterialSchema.partial();

export type ProjectMaterial = z.infer<typeof ProjectMaterialSchema>;
export type CreateProjectMaterial = z.infer<typeof CreateProjectMaterialSchema>;
export type UpdateProjectMaterial = z.infer<typeof UpdateProjectMaterialSchema>;
